import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "power",
  "use": "power-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"power\">\n<path d=\"M352 0l-288 288h176l-80 224 288-288h-176z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol